//ES5->ES6
export function ES6_Object_assign(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
}

export function ES6_String_endsWith(stringa: string, fine: string) {
    if (stringa != undefined) {
        if (stringa.length >= fine.length) {
            return (stringa.substr(stringa.length - fine.length, fine.length) == fine);
        }
    }
    return false;
}

export function ES6_String_startWith(stringa: string, inizio: string) {
    if (stringa != undefined) {
        if (stringa.length >= inizio.length) {
            return stringa.substr(0, inizio.length) == inizio;
        }
    }
    return false;
}

export function ES2017_padStart(stringa: string, targetLength: number, padString: string = " ") {
    for (let c = stringa.length; c < targetLength; c++) {
        stringa = padString + stringa;
    }
    return stringa.substr(0, targetLength);
}


// WEBPACK FOOTER //
// ./src/Compat.tsx